import axios from "axios";

const URL = "https://isolution.dev.br:8081/site";
//const URL = "http://localhost:8081/site";

const api = axios.create({
  baseURL: URL,
  timeout: 15000
});

/* ===========================
   INTERCEPTOR DE REQUEST
   Envia token automaticamente
=========================== */
api.interceptors.request.use(
  (config) => {
    const stored = localStorage.getItem("iContasApp");

    if (stored) {
      const { token } = JSON.parse(stored);

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* ===========================
   INTERCEPTOR DE RESPONSE
   Auto logout se token expirar
=========================== */
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("iContasApp");

      // Redireciona para login
      window.location.href = "/";
    }

    return Promise.reject(error);
  }
);

export default api;